import { connect } from 'react-redux'
import EventSetupPairings from '../../components/content/event_setup_pairings'
import {
  setGenericData,
  saveEventSettingsWidget,
  loadWidgetContent,
} from '../../actions/index'
import { filterSelectableDefaultTees, filterTeesByGender } from '../../components/content/event_setup/tee_filtering'

// const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { data, links, dataChanged } = ownProps.content

  const setDataChanged = () => dataChanged || dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], true))
  const set = (keys, value, dataChanged = true) => {
    dispatch(setGenericData(ownProps.widgetId, keys, value))
    dataChanged && setDataChanged()
  }

  const setHole = (hole) => {
    set([ 'data', 'courses_tees', 'variable_settings_hole_type' ], hole)
  }

  const getDefaultTeeForGender = (tees, gender) => filterTeesByGender(tees, gender)[0]?.value || ''

  const setCourseTee = (tee) => {
    set([ 'data', 'courses_tees', 'variable_settings_default_course' ], tee)

    if (tee in data.courses_tees.default_courses) {
      const course = data.courses_tees.default_courses[tee]
      const tees = filterSelectableDefaultTees(Object.values(course.tees), course.holes)

      set([ 'data', 'courses_tees', 'variable_settings_default_tee_m' ],
          getDefaultTeeForGender(tees, 'Male'))
      set([ 'data', 'courses_tees', 'variable_settings_default_tee_f' ],
          getDefaultTeeForGender(tees, 'Female'))

      if ((data.courses_tees.variable_settings_hole_type in course.holes) === false) {
        setHole(Object.values(course.holes)[0]?.value || -1)
      }
    }
  }

  const setShowByGender = (value) => {
    set(['data', 'courses_tees', 'default_tee_by_gender_enabled'], value)
    setCourseTee(Object.values(data.courses_tees.default_courses)[0]?.value || -1)
  }

  const setPairingGroupSize = (size) => {
    set([ 'data', 'pairing_group_size', 'value' ], size)
    if (size === 1 && data.courses_tees.variable_settings_default_course === -1) {
      setCourseTee(Object.values(data.courses_tees.default_courses)[0]?.value || -1) // set a first no-tee-sheet course
    }
  }

  return {
    setData: set,
    setHole: setHole,
    setCourseTee: setCourseTee,
    setPairingGroupSize,
    setShowByGender,
    save: () => {
      const pairingsData = { }
      for (const key of [ 'pairing_group_size', 'pairing_groups_count' in data && 'pairing_groups_count' ].filter(e => e)) {
        pairingsData[data[key].key] = data[key].value
      }

      const courseTeeKeys =
        [
          'variable_settings_default_course',
          'variable_settings_hole_type',
          'variable_settings_default_tee_m',
          'variable_settings_default_tee_f'
        ]

      for (const key of courseTeeKeys) {
        pairingsData[key] = data.courses_tees[key]
      }

      dispatch(saveEventSettingsWidget(ownProps.widgetId, links.save.path, {
        pairings_data: pairingsData,
        // course selection
        [data.course_selection.allow_players_from_mobile.key]: data.course_selection.allow_players_from_mobile.selected,
        ...('attester_required' in data.course_selection && data.course_selection.allow_players_from_mobile.selected && {
          [data.course_selection.attester_required.key]: data.course_selection.attester_required.selected,
        }),
      }))
      .then(({ state }) => {
        const handicapsWidgets = state.widgets[state.menu.selectedMenuItem].filter(w => w.content_type === 'event_setup_handicaps')
        handicapsWidgets.forEach(w => dispatch(loadWidgetContent(w.data_path, w.id)))
      })
    },
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(EventSetupPairings)

